import _createClass from "C:/Users/stefa/Documents/development/stefantrinh/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "C:/Users/stefa/Documents/development/stefantrinh/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "C:/Users/stefa/Documents/development/stefantrinh/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "C:/Users/stefa/Documents/development/stefantrinh/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "C:/Users/stefa/Documents/development/stefantrinh/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Text = 3D Text
 *
 * parameters = {
 *  font: <THREE.Font>, // font
 *
 *  size: <float>, // size of the text
 *  height: <float>, // thickness to extrude text
 *  curveSegments: <int>, // number of points on the curves
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into text bevel goes
 *  bevelSize: <float>, // how far from text outline (including bevelOffset) is bevel
 *  bevelOffset: <float> // how far from text outline does bevel start
 * }
 */
import { ExtrudeGeometry } from 'three';

var TextGeometry = /*#__PURE__*/function (_ExtrudeGeometry) {
  _inherits(TextGeometry, _ExtrudeGeometry);

  var _super = _createSuper(TextGeometry);

  function TextGeometry(text) {
    var _this;

    var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, TextGeometry);

    var font = parameters.font;

    if (font === undefined) {
      _this = _super.call(this); // generate default extrude geometry
    } else {
      var shapes = font.generateShapes(text, parameters.size); // translate parameters to ExtrudeGeometry API

      parameters.depth = parameters.height !== undefined ? parameters.height : 50; // defaults

      if (parameters.bevelThickness === undefined) parameters.bevelThickness = 10;
      if (parameters.bevelSize === undefined) parameters.bevelSize = 8;
      if (parameters.bevelEnabled === undefined) parameters.bevelEnabled = false;
      _this = _super.call(this, shapes, parameters);
    }

    _this.type = 'TextGeometry';
    return _possibleConstructorReturn(_this);
  }

  return _createClass(TextGeometry);
}(ExtrudeGeometry);

export { TextGeometry };